module.exports = "/_next/static/images/turelove-banner-d6de5b94.png";